import getBenchmark from './getBenchmark';

const onBenchmark = response => {
  getBenchmark().then(value => response(value));
};

export default onBenchmark;
